import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Inject, PieSeries, AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { PMCategoryBreakdownView } from '../../../../services/ReportingService';

interface PMByCategoryChartProps {
  categoryData: PMCategoryBreakdownView[];
}

const PMByCategoryChart: React.FC<PMByCategoryChartProps> = ({ categoryData }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          PMs by Category
        </Typography>
        {categoryData.length > 0 ? (
          <AccumulationChartComponent
            id="pm-by-category"
            tooltip={{ enable: true }}
            height="300px"
            legendSettings={{ visible: true }}
          >
            <Inject services={[PieSeries, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel]} />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={categoryData}
                xName="categoryName"
                yName="ticketCount"
                type="Pie"
                innerRadius="40%"
                dataLabel={{ visible: true, position: 'Outside', name: 'categoryName' }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PMByCategoryChart;
